<template>
  <base-web-page>
    <template v-slot:main>
        <el-main v-loading="loading" style="margin:0 auto;max-width:1100px;width:100%;">
          <el-breadcrumb separator-class="el-icon-arrow-right" style="padding:0px 5px;">
            <el-breadcrumb-item to="/account">My Account</el-breadcrumb-item>
            <el-breadcrumb-item :to="backToOrderLink">Order Detail</el-breadcrumb-item>
            <el-breadcrumb-item>Review</el-breadcrumb-item>
          </el-breadcrumb>
          <h1>Order Review</h1>
          <div>
              <write-review-item v-for="item in orderItems" :key="item.ID" :item="item"></write-review-item>
              <el-empty v-if="orderItems.length == 0" description="review is already uploaded"></el-empty>
          </div>
      </el-main>
    </template>
  </base-web-page>
</template>

<script>
import BaseWebPage from '../../components/base/BaseWebPage.vue'
import WriteReviewItem from '../../components/widgets/WriteReviewItem.vue'
import ModelReview from '../viewmodel/ModelReview.vue'

export default {
    extends: ModelReview,
    name: 'review',
    components: {
        BaseWebPage,
        WriteReviewItem
    }
}
</script>

<style>

</style>